module.exports = __webpack_public_path__ + "img/46.18939926.png";